/**
 * Google マップ起動ボタン
 *
 * 経由地は 9 件が上限のため、バックエンドが区間に割った URL をそのまま並べる。
 */

import { ExternalLink } from 'lucide-react'

import type { MapsSegment } from '@/api/types/route-plan'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export const MapsLaunchButtons = ({ segments, className }: { segments: MapsSegment[]; className?: string }) => {
  if (segments.length === 0) return null

  return (
    <div className={cn('space-y-2 p-3', className)}>
      {segments.length > 1 && (
        <p className="text-xs text-muted-foreground">経由地が 9 件を超えるため、区間に分けて開きます</p>
      )}
      {segments.map((segment) => (
        <Button
          key={segment.label}
          variant="outline"
          className="w-full justify-between px-3!"
          onClick={() => window.open(segment.url, '_blank', 'noopener,noreferrer')}
        >
          <span>
            {segments.length > 1 ? segment.label : 'Google マップで開く'}
            <span className="ml-2 text-xs tabular-nums text-muted-foreground">{segment.stop_count} 地点</span>
          </span>
          <ExternalLink size={14} />
        </Button>
      ))}
    </div>
  )
}
